import PhotoPlaceholder from '../components/photo-placeholder';
import InstagramStories from '../components/instagram-stories';
import { PROMOS } from '../data/promotions';
import { MES_ACTUAL } from '../data/content';
import { BUSINESS } from '../lib/business';
import { buildWhatsappUrl } from '../lib/whatsapp';
import { eyebrow, h1, bodyText, pageWrap } from '../lib/styles';

const Promotions = () => (
  <div style={pageWrap}>
    <span style={eyebrow}>Promociones</span>
    <h1 style={h1}>{MES_ACTUAL}</h1>
    <p style={{ ...bodyText, maxWidth: '52ch', margin: '0 0 4vw' }}>
      Cambian cada mes. Menciónalas al agendar por WhatsApp.
    </p>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))', gap: 24 }}>
      {PROMOS.map((p) => (
        <article
          key={p.id}
          style={{
            background: '#FFF',
            border: '1px solid var(--ink-200)',
            borderRadius: 'var(--radius-xl)',
            padding: 30,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 16,
            boxShadow: 'var(--shadow-sm)',
          }}
        >
          <PhotoPlaceholder label={p.foto} shape="circle" style={{ width: 180 }} />
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 400,
              fontSize: 27,
              color: 'var(--ink-900)',
              margin: 0,
            }}
          >
            {p.nombre}
          </h2>
          <p style={{ fontSize: 14.5, lineHeight: 1.65, color: 'var(--ink-600)', margin: 0 }}>{p.desc}</p>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
            <span style={{ fontFamily: 'var(--font-display)', fontSize: 34, color: 'var(--rose-700)' }}>
              {p.precio}
            </span>
            <span style={{ fontSize: 15, color: 'var(--ink-400)', textDecoration: 'line-through' }}>{p.antes}</span>
          </div>
          <span style={{ fontSize: 11, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--ink-500)' }}>
            {p.vigencia}
          </span>
          <a
            href={buildWhatsappUrl(BUSINESS.whatsapp, `Hola Zenya, me interesa la promoción "${p.nombre}".`)}
            target="_blank"
            rel="noreferrer"
            style={{
              width: '100%',
              textAlign: 'center',
              background: 'var(--rose-700)',
              color: '#FFF',
              fontSize: 13,
              letterSpacing: '.06em',
              padding: 13,
              borderRadius: 'var(--radius-pill)',
            }}
          >
            Quiero esta promoción
          </a>
        </article>
      ))}
    </div>
    <InstagramStories />
  </div>
);

export default Promotions;
